import React, { FunctionComponent } from "react";
import DefaultPrintOptions from "./DefaultPrintOptions";

const DefaultOptionsTab: FunctionComponent = function DefaultOptionsTab() {
	return (
		<DefaultPrintOptions />
	);
};

export = DefaultOptionsTab;